module.exports = __webpack_public_path__ + "img/default_mentor.812fdac0.png";